<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
      <router-link class="navbar-brand" to="/">
        Podologie Boldt
      </router-link>
    </template>
    <template slot="navbar-menu">
      <drop-down
              tag="li"
              title="Infos"
              icon="mdi mdi-text"
              class="nav-item"
      >
        <nav-link to="/legal">
          <div class="logo-container">
            <span class="mdi mdi-file-document-outline"></span>
          </div>
          <p class="ml-2">Impressum</p>
        </nav-link>
        <nav-link to="/privacy">
          <div class="logo-container">
            <span class="mdi mdi-account-eye-outline"></span>
          </div>
          <p class="ml-2">Datenschutzerklärung</p>
        </nav-link>
        <nav-link to="/accessibility">
          <div class="logo-container">
            <span class="mdi mdi-wheelchair"></span>
          </div>
          <p class="ml-2">Barrierefreiheit</p>
        </nav-link>
      </drop-down>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Folgen Sie uns auf Instagram"
          data-placement="bottom"
          href="https://www.instagram.com/autoedge24"
          target="_blank"
        >
          <div class="logo-container">
            <span class="mdi mdi-instagram"></span>
          </div>
          <p class="d-lg-none d-xl-none ml-2">Instagram</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Kontaktieren Sie uns per Whatapp"
          data-placement="bottom"
          href="https://wa.me/4917655980480"
          target="_blank"
        >
          <div class="logo-container">
            <span class="mdi mdi-whatsapp"></span>
          </div>
          <p class="d-lg-none d-xl-none ml-2">Whatapp</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavLink,
    [Popover.name]: Popover
  }
};
</script>

<style scoped>
.container {
  flex-direction: row;
}
.logo-container {
  height: 22px !important;
  width: 22px !important;
  display: flex;
  align-items: center;
  justify-content: center;

  .mdi {
    height: 100%;
    width: 100%;

    font-size: 20px;
    line-height: 20px;
  }
}
.logo-img {
  height: 100%;
  width: 100%;
}
.nav-item {
  width: 100%;

  .nav-link {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
}
</style>
